export default "__VITE_ASSET__CL4O8vzo__"